"use client";

import useSWR from "swr";

import SWR_KEYS from "@/constants/swr-keys";
import { normalizeSingleFilterFormData } from "@/helpers/request-helpers";
import INotification from "@/interfaces/notification.interface";
import notificationService from "@/services/notification.service";
import { IFilter } from "@/types/filter.types";
import { PaginatedResponse, RequestPagination, RequestsBaseReturn } from "@/types/requests.types";

export type Return = RequestsBaseReturn<PaginatedResponse<INotification> | null>;

export interface Props extends RequestPagination {
  filters: IFilter<INotification>[];
}

type GetAllSwrParams = [string, number, number, IFilter<INotification>[]];

const useGetNotifications = ({ pageNumber, pageSize, filters }: Props): Return => {
  const normalizedFilter = normalizeSingleFilterFormData(filters, "detail");

  const fetcher = useSWR<PaginatedResponse<INotification>, Error, GetAllSwrParams>(
    [SWR_KEYS.getNotifications, pageNumber, pageSize, normalizedFilter],
    ([, _pageNumber, _pageSize, _filters]) =>
      notificationService.filter(_filters, { pageNumber: _pageNumber, pageSize: _pageSize }),
    { revalidateOnFocus: false }
  );
  const { data = null, isValidating: isLoading, error } = fetcher;
  return { data, isLoading, error };
};

export default useGetNotifications;
